@if (products && products.length > 0) {
  <div class="row">
    <div class="col-12">
      <div class="product-detail_related-products">
        <h1
        i18n="
          product detail: alternative products
          header@@product.detail.alternative-products.header"
          >
        Available similar products
      </h1>
        <div class="js-overview-grid">
          <div class="overview-grid overview-grid--cms">
            @if (products) {
              @for (product of products; track product) {
                <product-item-grid
                  #productItemGridComponent
                  (lazyLoad)="productItemGridComponent.doLoad($event)"
                  (viewProductDetailClickEvent)="viewProductDetail($event)"
                  [loggedIn]="userService.isLoggedIn()"
                  [product]="product"
                  class="overview-product"
                  >
                </product-item-grid>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
